import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  handleTimeSlotModal,
} from "../../redux/slice/modalSlice";
import { setTimeSlot } from "../../redux/slice/homeSlice";

const TimeSlotModal = () => {
  const dispatch = useDispatch();
  const timeSlotModal = useSelector((state) => state.modal.timeSlotModal);
  const selectedSlot = useSelector((state) => state.home.selectedSlot);

  const timeSlot = [
    { id: 0, slot: "09:00 AM - 11:00 AM" },
    { id: 1, slot: "11:00 AM - 01:00 PM" },
    { id: 2, slot: "02:00 PM - 04:00 PM" },
    { id: 3, slot: "04:00 PM - 06:00 PM" },
  ];

  if (!timeSlotModal) return;

  return (
    <div className="popup show" id="select_time_slot_popup">
      <div className="popup-box">
        <Link
          to=""
          className="close-popup"
          onClick={() => {
            dispatch(setTimeSlot(""));
            dispatch(handleTimeSlotModal(false));
          }}
        >
          X
        </Link>
        <div className="popup-box-inner">
          <span className="icon bluebg">
            <img src="/images/time-slot.png" alt="" />
          </span>
          <h5>Select Time Slot</h5>
          <p className="small">
            Choose a preferred time slot for our team to help you re-enable the
            ERP sync
          </p>
          <form>
            <ul id="time_slot">
              {timeSlot.map((item, ind) => (
                <li
                  key={item.id}
                  className={selectedSlot.id === ind ? "selected" : ""}
                  onClick={() => dispatch(setTimeSlot(item))}
                >
                  {item.slot}
                </li>
              ))}
            </ul>
            <button
              type="button"
              className="btn btn-block btn-gold"
              id="time_slot_confirmed"
              onClick={() => {
                dispatch(setTimeSlot(""));
                dispatch(handleTimeSlotModal(false));
              }}
            >
              Confirm Time Slot
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default TimeSlotModal;
